import React, { useContext, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { ChudidharContext } from "../../../context/chudidharContext";
import ChudiDisplay from "./chudidisplay";
import { useTranslation } from 'react-i18next';

const ChudiList=()=>{
    const [blouseList, setBlouseList] = useState("All");
    const {chudidharData,allchudidharData}=useContext(ChudidharContext);
    const [filterBlouse,setFilterBlouse]=useState("");
    const [filterSubBlouse,setFilterSubBlouse]=useState("");
    const { t, i18n } = useTranslation();
    const chudi_filter_Data = t('main.chudi_fiter_buttons', { returnObjects: true });

    const FitlerBlouseData=allchudidharData.filter(each=>(
        each.name.toLowerCase().includes(filterBlouse.toLowerCase())
    ))
    const FitlerBlouseSubData=chudidharData.filter(each=>(
        each.name.toLowerCase().includes(filterSubBlouse.toLowerCase())
    ))

    const filteredItems = chudidharData.reduce((acc, category) => {
        if (category.name === blouseList) {
            acc.push(...category.items);
        }
        return acc;
        }, []);
    
    const handleSelect = (key) => {
        setBlouseList(key);
    };
    return(
        <>
          <div>
            <Col className="pt-1" lg={12}>
                <Button variant={blouseList === "All" ? "dark px-1":"outline-dark px-1"} size="sm"
                onClick={()=>handleSelect("All")}>{chudi_filter_Data[0]}</Button>
                <Button variant={blouseList === "Basic" ? "dark mx-1":"outline-dark mx-1"} size="sm"
                onClick={()=>handleSelect("Basic")}>{chudi_filter_Data[1]}</Button>
                <Button variant={blouseList === "Aline" ? "dark px-1":"outline-dark px-1"} size="sm"
                onClick={()=>handleSelect("Aline")}>{chudi_filter_Data[2]}</Button>
                <Button variant={blouseList === "Princess Cut" ? "dark mx-1":"outline-dark mx-1"} size="sm"
                onClick={()=>handleSelect("Princess Cut")}>{chudi_filter_Data[3]}</Button>
                <Button variant={blouseList === "Umbrella" ? "dark px-1":"outline-dark px-1"} size="sm"
                onClick={()=>handleSelect("Umbrella")}>{chudi_filter_Data[4]}</Button>
                <Button variant={blouseList === "Pants" ? "dark mx-1":"outline-dark mx-1"} size="sm"
                onClick={()=>handleSelect("Pants")}>{chudi_filter_Data[5]}</Button>
                <Button variant={blouseList === "Lehenga" ? "dark mx-1":"outline-dark mx-1"} size="sm"
                onClick={()=>handleSelect("Lehenga")}>{chudi_filter_Data[6]}</Button>
            </Col>
            </div>
            {blouseList === "All" ? (<>
                <div className="d-flex">
                <Col className="" >
                   <Form.Control type="text" 
                   onChange={(e)=>setFilterBlouse(e.target.value)}
                   placeholder="Search By Items..." />
                 </Col>
                 <Col className="mt-2 mx-1" lg={5} sm={4} md={4}>
                   <p className="text-dark px-2">{t('main.search_total')} {FitlerBlouseData.length}</p>
                 </Col>
                 </div>
                 </>)
                 :
                 (<>
                 <div className="d-flex m-0">
                 <Col className="" >
                   <Form.Control type="text" 
                   onChange={(e)=>setFilterSubBlouse(e.target.value)}
                   placeholder="Search By Items..." />
                 </Col>
                 <Col className="mt-2 mx-1" lg={5} sm={4} md={4}>
                   <p className="text-dark px-2">{t('main.search_total')} {filteredItems.length}</p>
                 </Col>
                 </div>
                 </>)
                 }

             {blouseList === "All" ? (<>
                <div className="leftside_items">
                {FitlerBlouseData.map(each=>{
                    if(blouseList === "All"){
                        return(
                        <ChudiDisplay  
                        key={each.id}
                        icon={each.icon}
                        name={each.name}
                        data={each} >
                            {/* <p className="text-primary striped-pattern">Paid</p> */}
                    </ChudiDisplay>
                    )}
                })}
                
                 </div>
                 </>)
                 :
                 (<>
                 <div className="leftside_items">
                 {filteredItems.map(each=>(
                   each.name.toLowerCase().includes(filterSubBlouse.toLowerCase()) &&
                    <ChudiDisplay key={each.id}
                        icon={each.icon}
                        name={each.name}
                        data={each}>
                    </ChudiDisplay>
                ))}
                 
                 </div>
                 </>)
                 }
                 
            
            
            
        </>
    )
}
export default ChudiList